import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent'
import {Button, Input} from 'reactstrap'
import Icon from "./../icon/FAIcon";
import AbstractField from "./AbstractField";
import Tag from "./../tag/Tag";
import TagItem from "./../tag/TagItem";

/**
 * Field, který umožňuje zadávat hodnoty pomocí seznamu tagů (seznam položek s křížkěm) jako seznam objektů.
 */
class ObjectTagField extends AbstractField {
    static PropTypes = {
        renderTagContent: React.PropTypes.func,
        equalsItems: React.PropTypes.func, // funkce (a, b) => return bool, je to funkce na porovnání dvou položek, pro docílení nemožnosti vícenásobného přiřazení položky s jedním id, pokud není uvedeno, porovnává se na ===
        // fieldComponent: React.PropTypes.element.isRequired,
        // fieldProps: React.PropTypes.element.isRequired,
    };

    static defaultProps = {
        getItemValue: i => i ? i.name : "",
        equalsItems: (a, b) => a === b,
    };

    handleAddTag = (inputValue) => {
        const {equalsItems, value, onChange} = this.props;

        let found = false;
        for (let a=0; a<value.length; a++) {
            if (equalsItems(value[a], inputValue)) {
                found = true;
                break;
            }
        }

        if (!found) {
            const newValue = [
                ...value,
                inputValue
            ];

            onChange(newValue);
        }
    };

    handleRemoveTag = (index) => {
        const {value, onChange} = this.props;
        const newValue = [
            ...value.slice(0, index),
            ...value.slice(index + 1)
        ];

        onChange(newValue);
    };

    render() {
        const {className, getItemValue, onBlur, value, onChange, renderTagContent, fieldComponent, fieldProps, ...props} = this.props;

        // const field = (
        //     <Input
        //         type="text"
        //         {...props}
        //     />
        // );

        const inputField = React.createElement(fieldComponent, {
            ...fieldProps,
            value: null,
            onChange: this.handleAddTag
        });

        let tags;
        if (value) {
            tags = <Tag {...props}>
                {value.map((v, index) => <TagItem key={index} onRemove={() => this.handleRemoveTag(index)}>
                        {renderTagContent(v)}
                    </TagItem>
                )}
            </Tag>
        }

        return <div className={className}>
            {inputField}
            {tags}
        </div>
    }
}
export default ObjectTagField;
